import { ReactNode } from 'react';
import { Groups, Tune, Notifications, Lock, Hub, Palette } from '@mui/icons-material';

/**
 * Descriptor de una sección del hub de Configuración.
 * - `*Key`: claves de traducción del namespace `Settings`.
 * - `route`: destino al hacer clic (solo si `available` es true).
 * - `available`: false pinta la tarjeta como "Próximamente" y la desactiva.
 * - `requiredPermission`: si está presente, la sección solo es visible cuando el
 *   usuario tiene ese permiso. Es la única fuente de verdad: la usan tanto el hub
 *   de Configuración como el menú lateral para decidir si mostrar la entrada.
 */
export interface SettingsSection {
  id: string;
  icon: ReactNode;
  iconBg: string;
  iconColor: string;
  titleKey: string;
  descriptionKey: string;
  ctaKey: string;
  route?: string;
  available: boolean;
  requiredPermission?: string;
}

export const settingsSections: SettingsSection[] = [
  {
    id: 'instructors',
    icon: <Groups />,
    iconBg: '#e7f6ee',
    iconColor: '#16a34a',
    titleKey: 'instructorsTitle',
    descriptionKey: 'instructorsDescription',
    ctaKey: 'manage',
    route: '/configuracion/instructores',
    available: true,
    requiredPermission: 'instructor.read',
  },
  // {
  //   id: 'general',
  //   icon: <Tune />,
  //   iconBg: '#eef3fb',
  //   iconColor: '#2563eb',
  //   titleKey: 'generalTitle',
  //   descriptionKey: 'generalDescription',
  //   ctaKey: 'comingSoon',
  //   available: false,
  // },
  // {
  //   id: 'notifications',
  //   icon: <Notifications />,
  //   iconBg: '#fdf2e7',
  //   iconColor: '#e08a1e',
  //   titleKey: 'notificationsTitle',
  //   descriptionKey: 'notificationsDescription',
  //   ctaKey: 'comingSoon',
  //   available: false,
  // },
  // {
  //   id: 'security',
  //   icon: <Lock />,
  //   iconBg: '#fdeceb',
  //   iconColor: '#e8453c',
  //   titleKey: 'securityTitle',
  //   descriptionKey: 'securityDescription',
  //   ctaKey: 'comingSoon',
  //   available: false,
  // },
  // {
  //   id: 'integrations',
  //   icon: <Hub />,
  //   iconBg: '#f3eefb',
  //   iconColor: '#7b3fe4',
  //   titleKey: 'integrationsTitle',
  //   descriptionKey: 'integrationsDescription',
  //   ctaKey: 'comingSoon',
  //   available: false,
  // },
  // {
  //   id: 'appearance',
  //   icon: <Palette />,
  //   iconBg: '#eef9f1',
  //   iconColor: '#2b9d4f',
  //   titleKey: 'appearanceTitle',
  //   descriptionKey: 'appearanceDescription',
  //   ctaKey: 'comingSoon',
  //   available: false,
  // },
];

export default settingsSections;
